<template>
  <b-modal
    id="tags-settings-modal"
    size="lg"
    :ok-title="trans('close')"
    ok-only
    @shown="onShown"
    @hidden="onHidden"
  >
    <template #modal-title>
      {{ trans('manage') + ': ' + placeholder.toLowerCase() }}
    </template>
    <DynamicTableAndForm
      type="tag"
      :loadUrl="`/organization/${organization.id}/tags?type=${type}`"
      :url="`/organization/${organization.id}/tags`"
      :fields="fields"
      showFilter
      validation
    />
  </b-modal>
</template>

<script>
  import DynamicTableAndForm from './../../../common/components/DynamicTableAndForm'
  export default {
    props: {
      organization: Object,
      type: String,
      placeholder: {
        type: String,
        default: trans('tags'),
      },
      label: {
        type: String,
        default: 'tag',
      },
    },
    components: {
      DynamicTableAndForm
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        items: null,
        fields: [
          {
            key: 'name',
            label: trans('name'),
            sortable: true,
            required: true,
          },
          {
            key: 'created_at',
            label: trans('created_on'),
            formatter(value, key, item) {
              return moment(value).format('LL')
            },
            hide: true,
            sortable: true,
          },
          {
            key: 'action',
            hide: true,
          },
        ],
      }
    },
    methods: {
      onShown() {
      },
      onHidden() {
        window.location.reload()
      },
    },
    mounted() {
      window.tagsSettingsModal = this
    },
  }
</script>